import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { OverlayPanel } from 'primeng/overlaypanel';
import { BreadcrumbService } from 'app/breadcrumb.service';
import { Product } from 'app/products/domain/product';
import { ProductStock } from 'app/products/domain/ProductStock';
import { IProduct } from 'app/Sales/point-of-sale/domain/IProduct';
import { ICompany } from 'app/shared/Domains/company';
import { IUser } from 'app/shared/Domains/IUser';
import { IRole } from 'app/shared/Domains/role';
import { AppServiceManager } from 'common/services/appServiceManager';
import { AuthService } from 'common/services/auth.service';
import { Configuration } from 'config/config';
import { PurchaseOrder } from '../domain/purchaseOrder';
import { Supplier } from '../domain/supplier';
import { IBranch } from 'app/shared/Domains/branch';
import { LanguageService } from 'app/LanguageService/Language.Service';
@Component({
  selector: 'app-purchase-order',
  templateUrl: './purchase-order.component.html',
  styleUrls: ['./purchase-order.component.css']
})
export class PurchaseOrderComponent implements OnInit {
  purchaseOrderId: string;
  mode: string;
  product: Product;
  supplier: Supplier;
  supplierSearch: Supplier;
  user: IUser;
  role: IRole;
  productsInPanel: any[];
  suppliersInPanel: any[];
  sourceProducts: any[];
  loading: boolean;
  paymentMode: any;
  orderProduct: IProduct[];
  vatTax: number;
  index: number = 0;
  newPurchaseOrder: PurchaseOrder;
  enterSteps: any[];
  currentStep: any;
  company: ICompany;
  first: number = 0;
  firstOfSupplierOverlay: number = 0;
  rowIndex: number = -1;
  sourceSuppliers: any[];
  selectedSupplier: Supplier[];
  paymentOptions = [];
  disableCheckoutOnSuccess: boolean = false;
  isFulFil: boolean = false;
  fulFilButtonName: string = "Fulfil";
  Product: Product;
  stock: ProductStock;
  branch: IBranch;

  constructor(
    private LanguageService: LanguageService,
    private appServiceManager: AppServiceManager,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    public config: Configuration,
    private route: ActivatedRoute,
    private router: Router,
    private breadcrumbService: BreadcrumbService,
  ) {
    route.params.subscribe((params) => {
      this.purchaseOrderId = params["id"];
      if (this.purchaseOrderId !== null && this.purchaseOrderId !== undefined) {
        this.getPurchaseOrderById();
        this.mode = 'edit';
      } else {
        this.mode = 'add';
      }
      this.breadcrumbService.setItems([
        { label: "Purchases", routerLink: ["/purchase-orders"] },
        { label: "Purchase Order" },
      ]);
    });
  }
  setLabel(label) {
    return this.LanguageService.GetCurrentLanguage("PurchaseOrderComponent", label);
  }
  ngOnInit(): void {
    this.user = AuthService.getLoggedInUser();
    this.role = AuthService.getLoggedInRole();
    this.company = new ICompany();
    this.getCompany();
    this.productsInPanel = [];
    this.suppliersInPanel = [];
    this.Product = new Product();
    this.stock = new ProductStock();
    this.product = new Product();
    this.supplier = new Supplier();
    this.supplierSearch = new Supplier();
    this.newPurchaseOrder = new PurchaseOrder();
    this.newPurchaseOrder.paid = 0;
    this.getProducts();
    this.getBranch();
    this.getSuppliers();
    this.orderProduct = [];
    this.selectedSupplier = [];
    this.currentStep = 0;
    this.sum();
    this.paymentOptions = [
      { label: 'Cash - Reception', value: 'Cash-Reception' },
    ];
    this.paymentMode = "Cash-Reception";
    this.enterSteps = [
      "rowQuantity-" + this.index,
      "rowUnitPrice-" + this.index,
      "rowDiscount-" + this.index,
    ];

    if (this.newPurchaseOrder.status != undefined && this.newPurchaseOrder.status == 'FULFILLED') {
      this.isFulFil = true;
    } else {
      this.isFulFil = false;
    }
  }

  getCompany() {
    this.company = AuthService.getLoggedInCompanyBranch();
    if(!this.company){
    this.appServiceManager.get("companies/" + this.user.company).subscribe(
      (res) => {
        if (res) {
          this.company = res;
        } else {
          this.company = new ICompany();
          this.messageService.clear();
          this.messageService.add({
            severity: "info",
            summary: "Info Message",
            detail: "Something Went Wrong",
          });
        }
      },
      (error) => {
        this.company = new ICompany();
        this.messageService.clear();
        this.messageService.add({
          severity: "error",
          summary: "Error Message",
          detail: error,
        });
      }
    );
   }
  }
  getBranch() {
    this.branch = AuthService.getLoggedInCurrentBranch();
        if(this.branch){
            if (Array.isArray(this.branch.payments)) {
              this.branch.payments.forEach(payment => {
                const existingBank = this.paymentOptions.find(option => option.value === `${payment.type}-${payment.name}`);
                if (!existingBank) {
                  this.paymentOptions.push({
                    label: `${payment.type} - ${payment.name}`,
                    value: `${payment.type}-${payment.name}`
                  });
                }
              });
            }
      }
    if(!this.branch){          
    this.appServiceManager.get('branches/' + this.user.branch).subscribe((res) => {
      if (res) {
        this.branch = res;
        res.payments.forEach(payment => {
          const existingBank = this.paymentOptions.find(option => option.value === `${payment.type}-${payment.name}`);
          if (!existingBank) {
            this.paymentOptions.push({
              label: `${payment.type} - ${payment.name}`,
              value: `${payment.type}-${payment.name}`
            });
          }
        });
      } else {
        this.branch = new IBranch();
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
      }
    },
      (error) => {
        this.branch = new IBranch();
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
    }
  }

  onPaymentModeChange(value: string) {
    this.paymentMode = value;
  }
  getPurchaseOrderById() {
    this.loading = true;
    this.appServiceManager.get("purchaseOrder/getPurchaseOrder/" + this.purchaseOrderId).subscribe(
      data => {
        this.newPurchaseOrder = data;
        let suppliers = [];
        suppliers.push(this.newPurchaseOrder.supplier);
        this.selectedSupplier = suppliers;
        this.orderProduct = this.newPurchaseOrder.products;
        this.loading = false;
        if (this.newPurchaseOrder.status != undefined && this.newPurchaseOrder.status == 'FULFILLED') {
          this.isFulFil = true;
          this.fulFilButtonName = "FulFilled";

        } else {
          this.isFulFil = false;
          this.fulFilButtonName = "FulFil";

        }
      },
      error => {
        this.loading = false;
        alert(error);
      }
    );
  }

  getProducts() {
    this.loading = true;
    this.appServiceManager.get(`products/company/${this.user.company}/branch/${this.user.branch}`).subscribe((res: any) => {
      if (res.length > 0) {
        const products = res.filter(r => r.type != "Ingredients Based");
        products.map(p => {
          if (p.unit != "Count") {
            if (p.unit == "g") {
              p.totalQuantity = this.getKgFromG(p.totalQuantity) + " Kg";
            }
            if (p.unit == "ml") {
              p.totalQuantity = this.getLFromMl(p.totalQuantity) + " Liter";
            }
          }
        })
        this.productsInPanel = products;
        this.sourceProducts = products;

      } else {
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
      }
      this.loading = false;
    },
      (error) => {
        this.loading = false;
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
  }

  getKgFromG(value) {
    if (value <= 0) {
      return 0;
    }
    const valueInKg = value / 1000;
    return valueInKg;
  }

  getLFromMl(value) {
    if (value <= 0) {
      return 0;
    }
    const valueInKg = value / 1000;
    return valueInKg;
  }

  getSuppliers() {
    this.loading = true;
    this.appServiceManager.get(`suppliers/company/${this.user.company}/branch/${this.user.branch}/getAllSuppliers`).subscribe((res: any) => {
      if (res.length > 0) {
        this.suppliersInPanel = res;
        this.sourceSuppliers = res;
      } else {
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
      }
      this.loading = false;
    },
      (error) => {
        this.loading = false;
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
  }


  searchPanelProducts(event, value, type) {
    if (!(event.keyCode == 40 || event.keyCode == 38)) {
      let matchedName = [];
      if (value !== null && value !== undefined && value.toString().length > 0) {
        if (value == "") {
          this.productsInPanel = Object.assign([], this.sourceProducts);
        }
        if (!value) {
          this.productsInPanel = Object.assign([], this.sourceProducts);
        }
        if (value != "") {

          if (type === "name") {
            matchedName = Object.assign([], this.sourceProducts).filter(
              cust => cust.name ? cust.name.toLowerCase().indexOf(value.toLowerCase()) > -1 : null);
          }

          const distinct = (value, index, self) => {
            return self.indexOf(value) === index;
          }
          const source = matchedName;
          this.productsInPanel = source.filter(distinct);

          if (this.productsInPanel.length === 0) {
            this.productsInPanel = [];
            this.messageService.clear();
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
          } else {
            this.first = 0;
            this.rowIndex = -1;
            if (this.productsInPanel.length === 1) {
              this.first = 0;
              this.rowIndex = -1;
            }
            this.productsInPanel = [...this.productsInPanel];
          }
        }
      } else {
        this.productsInPanel = Object.assign([], this.sourceProducts);
        this.productsInPanel = [...this.productsInPanel];
      }
    }

  }

  onPageChange(event) {
    this.first = event.first;
  }

  onSupplierPageChange(event) {
    this.firstOfSupplierOverlay = event.first;
  }

  onProductRowSelect(event, productsPanel: OverlayPanel) {
    if (this.selectedSupplier.length == 0) {
      this.messageService.clear();
      this.messageService.add({ severity: 'warn', summary: 'Warning Message', detail: 'Please select the Supplier first' });
    } else {
      const check = this.orderProduct.filter(x => x.code === event.data.code);
      if (check.length > 0) {
        this.messageService.clear();
        this.messageService.add({ severity: 'warn', summary: 'Warning Message', detail: 'Product Already Added' });
      } else {
        const productToBeSale = new IProduct();
        productToBeSale._id = event.data._id;
        productToBeSale.productId = event.data._id;
        productToBeSale.name = event.data.name;
        productToBeSale.code = event.data.code;
        productToBeSale.quantity = 1;
        productToBeSale.unit = event.data.unit;
        productToBeSale.totalQuantity = event.data.totalQuantity;
        productToBeSale.cost = event.data.cost; //purchase price
        productToBeSale.wholeSalePrice = event.data.wholeSalePrice; //wholeSale price
        productToBeSale.normalPrice = event.data.normalPrice; //Sale or Retail Price
        productToBeSale.subTotal = productToBeSale.quantity * productToBeSale.cost;
        const products = [...this.orderProduct];
        products.push(productToBeSale);
        this.orderProduct = products;
        productsPanel.hide();
        this.sum();
        this.index = this.orderProduct.length - 1;
        this.enterSteps = [
          "rowQuantity-" + this.index,
          "rowUnitPrice-" + this.index,
          "rowDiscount-" + this.index,
        ];
        setTimeout(() => {
          document.getElementById(this.enterSteps[0]).focus()
          this.currentStep = 0;

        }, 500);
      }
    }

  }

  searchPanelSuppliers(event, value, type) {
    if (!(event.keyCode == 40 || event.keyCode == 38)) {
      let matchedName = [];
      if (value !== null && value !== undefined && value.toString().length > 0) {
        if (value == "") {
          this.suppliersInPanel = Object.assign([], this.sourceSuppliers);
        }
        if (!value) {
          this.suppliersInPanel = Object.assign([], this.sourceSuppliers);
        }
        if (value != "") {

          if (type === "name") {
            matchedName = Object.assign([], this.sourceSuppliers).filter(
              cust => cust.name ? cust.name.toLowerCase().indexOf(value.toLowerCase()) > -1 : null);
          }

          const distinct = (value, index, self) => {
            return self.indexOf(value) === index;
          }
          const source = matchedName;
          this.suppliersInPanel = source.filter(distinct);

          if (this.suppliersInPanel.length === 0) {
            this.suppliersInPanel = [];
            this.messageService.clear();
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
          } else {
            this.firstOfSupplierOverlay = 0;
            if (this.suppliersInPanel.length === 1) {
              this.firstOfSupplierOverlay = 0;
            }
            this.suppliersInPanel = [...this.suppliersInPanel];
          }
        }
      } else {
        this.suppliersInPanel = Object.assign([], this.sourceSuppliers);
        this.suppliersInPanel = [...this.suppliersInPanel];
      }
    }

  }

  onSupplierRowSelect(event, supplierPanel: OverlayPanel) {
    this.supplier = new Supplier();
    this.supplier.name = event.data.name;
    this.supplier.profile = event.data.profile;
    this.supplier.phone = event.data.phone;
    this.supplier._id = event.data._id;
    let suppliers = [];
    suppliers.push(this.supplier);
    this.selectedSupplier = suppliers;
    supplierPanel.hide();
  }

  removeSelectedProduct(product) {
    let products = [...this.orderProduct];
    let index = this.orderProduct.indexOf(product);
    if (index > -1) {
      products.splice(index, 1);
      this.orderProduct = products;
      this.index = this.orderProduct.length - 1;
      this.sum();
      this.enterSteps = [
        "rowQuantity-" + this.index,
        "rowUnitPrice-" + this.index,
        "rowDiscount-" + this.index,
      ];

      setTimeout(() => {
        if (this.orderProduct.length > 0) {
          document.getElementById(this.enterSteps[0]).focus()
          this.currentStep = 0;
        }
      }, 300);
    }
  }

  generateOrder() {
    this.confirmationService.confirm({
      message: "Are you sure you want to proceed ?",
      accept: () => {
        let user = JSON.parse(localStorage.getItem("currentUser"));
        this.newPurchaseOrder.purchaseOrderNumber = Math.round(Math.random() * 1000).toString();
        this.newPurchaseOrder.company = user.company;
        this.newPurchaseOrder.branch = user.branch;
        this.newPurchaseOrder.createdBy = this.user._id;
        this.newPurchaseOrder.supplier = this.supplier;
        this.newPurchaseOrder.products = this.orderProduct;
        this.newPurchaseOrder.createdBy = this.user.name;
        this.appServiceManager.post("purchaseOrder/createPurchaseOrder", this.newPurchaseOrder).subscribe((res: any) => {
          if (res) {
            this.newPurchaseOrder = res.PurchaseOrder;
            this.disableCheckoutOnSuccess = true;
            setTimeout(() => {
              this.printPurchaseOrder();
              document.getElementById("suspendButton").focus();
              this.router.navigateByUrl('purchase-order/' + this.newPurchaseOrder._id);
            }, 300);
            this.messageService.clear();
            this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Generated Successfully' });
          } else {
            this.messageService.clear();
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
          }
        },
          (error) => {
            this.messageService.clear();
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
          });
      },
      reject: () => {
        console.log("reject");
      }
    });
  }


  updateOrder() {
    this.confirmationService.confirm({
      message: "Are you sure you want to update ?",
      accept: () => {
        const user = JSON.parse(localStorage.getItem("currentUser"));
        this.newPurchaseOrder.company = user.company;
        this.newPurchaseOrder.branch = user.branch;
        this.newPurchaseOrder.updatedBy = this.user.name;
        this.newPurchaseOrder.supplier = this.selectedSupplier[0];
        this.newPurchaseOrder.products = this.orderProduct;
        this.appServiceManager.put("purchaseOrder/updatePurchaseOrder/" + this.newPurchaseOrder._id, this.newPurchaseOrder).subscribe((res: any) => {
          if (res) {
            this.newPurchaseOrder = res.PurchaseOrder;
            this.messageService.clear();
            this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Order Successfully Updated' });
          } else {
            this.messageService.clear();
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
          }
        },
          (error) => {
            this.messageService.clear();
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
          });
      },
      reject: () => {
        console.log("reject");
      }
    });
  }

  fulfilOrder() {
    this.confirmationService.confirm({
      message: "Are you sure you want to Fulfill the order ?",
      accept: () => {
        const user = JSON.parse(localStorage.getItem("currentUser"));
        this.newPurchaseOrder.company = user.company;
        this.newPurchaseOrder.branch = user.branch;
        this.newPurchaseOrder.supplier = this.selectedSupplier[0];
        this.newPurchaseOrder.products = this.orderProduct;
        this.newPurchaseOrder.paymentMode = this.paymentMode;
        this.newPurchaseOrder.updatedBy = this.user.name;
        this.appServiceManager.put("purchaseOrder/fullfillPurchaseOrder/" + this.newPurchaseOrder._id, this.newPurchaseOrder).subscribe((res) => {
          if (res) {
            this.newPurchaseOrder = res.PurchaseOrder;
            this.getPurchaseOrderById();
            // this.messageService.clear();
            // this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Order Successfully Updated' });
            this.updateProductStockAfterFulfillingPurchaseOrder();

          } else {
            this.messageService.clear();
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
          }
        },
          (error) => {
            this.messageService.clear();
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
          });
      },
      reject: () => {
        console.log("reject");
      }
    });
  }

  suspendOrder() {
    this.disableCheckoutOnSuccess = false;
    this.newPurchaseOrder = new PurchaseOrder();
    this.newPurchaseOrder.remarks = undefined;
    this.selectedSupplier = [];
    this.orderProduct = [];
  }

  quantityChangeEvent(product, type) {
    let num = 0;
    if (type === "quantity" || type === "purchasePrice") {
      num = product.cost * product.quantity;
      product.subTotal = Math.round(num);
      let index = this.orderProduct.indexOf(product);
      this.orderProduct[index] = product;
      this.sum();

    }
  }

  deleteOrder() {
    this.confirmationService.confirm({
      message: "Are you sure you want to Delete ?",
      accept: () => {
        this.loading = true;
        let data = {
          modifiedBy: this.user._id
        };
        this.appServiceManager.put('purchaseOrder/deletePurchaseOrder/' + this.purchaseOrderId, data).subscribe((res: any) => {
          if (res.status === true) {
            this.messageService.clear();
            this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Successfully Deleted' });
            this.router.navigateByUrl('/purchase-orders')
          } else {
            this.messageService.clear();
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
          }
          this.loading = false;
        },
          (error) => {
            this.loading = false;
            this.messageService.clear();
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
          });
      }
    });
  }


  sum() {
    this.newPurchaseOrder.subTotal = 0;
    this.orderProduct.forEach(product => {
      this.newPurchaseOrder.subTotal = this.newPurchaseOrder.subTotal + product.subTotal;
      this.newPurchaseOrder.subTotal = Math.round(this.newPurchaseOrder.subTotal);
    });

  }

  updateProductStockAfterFulfillingPurchaseOrder() {
    this.appServiceManager.put("purchaseOrder/updatePurchaseOrderProductsStock", this.newPurchaseOrder.products).subscribe((res: any) => {
      if (res) {
        this.messageService.clear();
        this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Stock and Prices Updated' });
      } else {
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
      }
    },
      (error) => {
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      }
    );
  }

  printPurchaseOrder(): void {
    let printContents, popupWin;
    printContents = document.getElementById("purchaseOrder").innerHTML;
    popupWin = window.open(
      "",
      "_blank",
      "top=0,left=0,height=100%,width=auto"
    );
    popupWin.document.open();
    popupWin.document.write(`
      <html>
      <head>
        <title>Gym Invoice</title>
        <style>
            .invoice-box {
                max-width: 800px;
                margin: auto;
                padding: 30px;
                border: 1px solid #eee;
                box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
                font-size: 16px;
                line-height: 24px;
                font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
                color: #555;
            }

            .invoice-box table {
                width: 100%;
                line-height: inherit;
                text-align: left;
            }

            .invoice-box table td {
                padding: 5px;
                vertical-align: top;
            }

            .invoice-box table tr td:nth-child(n + 2) {
                text-align: right;
            }

            .invoice-box table tr.top table td {
                padding-bottom: 20px;
            }

            .invoice-box table tr.top table td.title {
                font-size: 45px;
                line-height: 45px;
                color: #333;
            }

            .invoice-box table tr.information table td {
                padding-bottom: 40px;
            }

            .invoice-box table tr.heading td {
                background: #eee;
                border-bottom: 1px solid #ddd;
                font-weight: bold;
            }

            .invoice-box table tr.details td {
                padding-bottom: 20px;
            }

            .invoice-box table tr.item td {
                border-bottom: 1px solid #eee;
            }
            .invoice-box table tr.item.last td {
                border-bottom: none;
            }
            .invoice-box table tr.item input {
                padding-left: 5px;
            }
            .invoice-box table tr.item td:first-child input {
                margin-left: -5px;
                width: 100%;
            }
            .invoice-box table tr.total td:nth-child(2) {
                border-top: 2px solid #eee;
                font-weight: bold;
            }
            .invoice-box input[type="number"] {
                width: 60px;
            }
            @media only screen and (max-width: 600px) {
                .invoice-box table tr.top table td {
                    width: 100%;
                    display: block;
                    text-align: center;
                }

                .invoice-box table tr.information table td {
                    width: 100%;
                    display: block;
                    text-align: center;
                }
            }
            .rtl {
                direction: rtl;
                font-family: Tahoma, "Helvetica Neue", "Helvetica", Helvetica, Arial,
                    sans-serif;
            }
            .rtl table {
                text-align: right;
            }
            .rtl table tr td:nth-child(2) {
                text-align: left;
            }
        </style>
      </head>
      <body>${printContents}</body>
      </html>
    `);
  }
}
